import type { Provider } from '@angular/core';
import { signal } from '@angular/core';
import type { BaseFacadeContext } from '@kerberos-compliance/compliance-shared-ui';
import { BASE_FACADE_CONTEXT, DatatableBaseConfig } from '@kerberos-compliance/compliance-shared-ui';

/**
 * Provides the BASE_FACADE_CONTEXT for AML Admin Desk.
 *
 * **API Behavior**:
 * - Admin API endpoints return data across all organizations the admin has access to
 * - Backend enforces admin permissions and filters data appropriately
 * - Client-side does NOT need to include `organizationId` in API requests
 *
 * **Pagination Config**:
 * - initialPage/pageSize pulled from `DatatableBaseConfig`
 *
 * @returns {Provider} Provider configuration for BASE_FACADE_CONTEXT
 */
export function provideBaseFacadeContext(): Provider {
  return {
    provide: BASE_FACADE_CONTEXT,
    useFactory: (): BaseFacadeContext => {
      return {
        organizationId: signal(undefined),
        pagination: {
          initialPage: DatatableBaseConfig.pageIndex,
          pageSize: DatatableBaseConfig.pageSize,
        },
      };
    },
  };
}
